import InsertOfferWrapper from "components/InsertOfferWrapper";
import InfoOfferForm from "scenes/InsertOffer/form/InfoOffer";
import { CustomAppPage } from "src/types/types";

const InfoOffer: CustomAppPage = () => (
  <InsertOfferWrapper title="Údaje o nabídce">
    <InfoOfferForm />
  </InsertOfferWrapper>
);

InfoOffer.hasHiddenFooter = true;

export default InfoOffer;
